//  字符串转数字
export const transNumber = (val) => {
  if (!val) {
    return 0;
  }
  if (typeof val === 'string') {
    return parseFloat(val);
  }
  return val;
};
